import React from "react";
import { useState } from "react";
import {Button} from "antd";
import Cookies from "js-cookie";
import i18n from "../../../i18n";

export default function CookiesMessage({isCookiesApproved, setCookiesApproved}) {

  const handleButtonClick = () => {
    Cookies.set(`cookies`, 'approved', {expires: 7000});
    setCookiesApproved(true);
  }

  return (
    (!isCookiesApproved && <div className="cookies-message">
      <p class="head">{i18n.t('landing.cookies')}</p>
      <p>Для улучшения работы сайта, анализа трафика и персонализации контента мы применяем файлы cookie и сервис Яндекс Метрика. Сервис собирает обезличенные данные о посещениях, включая: уникальные идентификаторы браузера, IP-адрес (с анонимизацией последнего октета), тип устройства, операционную систему, источник перехода, просмотренные страницы, глубину просмотра, время на сайте, а также статистические данные о регионе, возрасте и поле посетителей (определяются алгоритмами Яндекса). Эти данные являются обезличенными либо обрабатываются как персональные в соответствии с Политикой обработки персональных данных.</p>
      <p>Нажимая «Принять», вы даёте согласие на обработку указанных данных в целях, предусмотренных <a href="https://svetofore.com/privacy-page?tab=terms" target="blank">Политикой конфиденциальности</a>. Вы всегда можете отозвать согласие или настроить cookie в браузере. Инструкция по отказу от сбора данных Яндекс Метрикой: <a href="https://yandex.ru/support/metrica/general/opt-out.html" target="_blank">https://yandex.ru/support/metrica/general/opt-out.html</a>.</p>
      <Button className=""
              onClick={handleButtonClick}
              >{i18n.t('landing.buttons.cookies')}</Button>
    </div>)
  )
}
